// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Catalog-style list pages: Medications, Labs, Radiology, Physician Referrals,
 * Referring Providers, CPT, Organizations, Locations, ICD-10-CM, SmartPhrases,
 * Users, Access Control, Allergen Master, and Px Master.
 * Namespaced so other pages stay unchanged. */

.emr-catalog,
.emr-catalog *,
.emr-catalog *::before,
.emr-catalog *::after {
  border-radius: 0 !important;
}

.emr-mz-dashboard .emr-mz-main:has(.emr-catalog) {
  padding: 10px 12px 12px !important;
  max-width: none;
  overflow-x: hidden;
}

.emr-catalog {
  --emr-catalog-primary: #1976d2;
  --emr-catalog-primary-dark: #0d47a1;
  --emr-catalog-text: #212121;
  --emr-catalog-muted: #616161;
  --emr-catalog-border: #e0e0e0;
  --emr-catalog-surface: #ffffff;
  max-width: none;
  margin: 0;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  color: var(--emr-catalog-text);
  overflow-x: hidden;
}

.emr-catalog__pagehead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
  min-width: 0;
}

.emr-mz-dashboard .emr-catalog__title,
.emr-catalog__title {
  margin: 0;
  font-size: 20px !important;
  font-weight: 600;
  line-height: 1.25;
  color: var(--emr-catalog-text);
}

.emr-catalog__workspace {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
  align-items: start;
  min-width: 0;
}

.emr-catalog__side {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
  align-content: start;
  min-width: 0;
}

.emr-catalog__catalog {
  min-width: 0;
}

.emr-catalog .card.emr-catalog__section,
.emr-catalog__section {
  margin: 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  background: var(--emr-catalog-surface);
  border: 1px solid var(--emr-catalog-border);
  border-right: 3px solid var(--emr-catalog-primary);
  box-shadow: none;
  padding: 8px 12px 10px;
  box-sizing: border-box;
}

.emr-catalog__section-title {
  margin: 0 0 6px;
  font-size: 11px !important;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--emr-catalog-muted);
}

.emr-catalog__copy {
  margin: 0;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--emr-catalog-text);
}

.emr-catalog__section--notice {
  background: #fff8e1;
  border-color: #ffe082;
  border-right-width: 3px;
  border-right-color: var(--emr-catalog-primary);
}

.emr-catalog__section--notice .emr-catalog__section-title {
  color: #f57f17;
}

.emr-catalog__section--notice .emr-catalog__copy {
  color: #5d4037;
}

.emr-catalog__status-msg,
.emr-catalog__empty {
  padding: 28px 16px;
  text-align: center;
  font-size: 13px;
  color: var(--emr-catalog-muted);
}

.emr-catalog__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.emr-catalog__empty-icon {
  width: 32px;
  height: 32px;
  color: #bdbdbd;
}

.emr-catalog__error {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 28px 16px;
  text-align: center;
}

.emr-catalog__error-icon {
  width: 32px;
  height: 32px;
  color: #ef9a9a;
}

.emr-catalog__error-copy {
  margin: 0;
  max-width: 28rem;
  font-size: 13px;
  color: var(--emr-catalog-muted);
}

.emr-mz-dashboard .btn.emr-catalog__retry,
.emr-catalog__retry {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 14px;
  margin: 0;
  background: #fff !important;
  color: var(--emr-catalog-primary) !important;
  border: 1px solid var(--emr-catalog-primary);
  box-shadow: none;
}

.emr-mz-dashboard .btn.emr-catalog__retry:hover,
.emr-catalog__retry:hover {
  background: #e3f2fd !important;
}

.emr-catalog__table-wrap {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.emr-mz-dashboard table.emr-catalog__table,
.emr-catalog__table {
  display: table;
  width: 100%;
  min-width: 720px;
  border-collapse: collapse;
  position: static;
}

.emr-mz-dashboard table.emr-catalog__table thead {
  display: table-header-group;
  position: static;
  float: none;
  overflow: visible;
  width: auto;
}

.emr-mz-dashboard table.emr-catalog__table tbody {
  display: table-row-group;
}

.emr-mz-dashboard table.emr-catalog__table tr {
  display: table-row;
}

.emr-mz-dashboard table.emr-catalog__table th,
.emr-mz-dashboard table.emr-catalog__table td {
  display: table-cell;
  line-height: 1.25;
}

.emr-mz-dashboard .emr-catalog__table th {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--emr-catalog-muted);
  padding: 4px 12px;
  line-height: 1.25;
  border-bottom: 1px solid var(--emr-catalog-border);
  background: #fafbfc;
  white-space: nowrap;
}

.emr-mz-dashboard .emr-catalog__table td {
  font-size: 13px;
  font-weight: 400;
  padding: 4px 12px;
  line-height: 1.25;
  color: var(--emr-catalog-text);
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
}

.emr-catalog__name {
  font-weight: 600;
  color: var(--emr-catalog-primary-dark);
}

.emr-catalog__muted {
  font-size: 13px;
  color: var(--emr-catalog-muted);
}

.emr-catalog__status {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.emr-catalog__status--active {
  background: #e3f2fd;
  color: #1565c0;
}

.emr-catalog__status--transform {
  background: #fff8e1;
  color: #f57f17;
}

.emr-catalog__status--inactive {
  background: #eceff1;
  color: #546e7a;
}

.emr-catalog__token--placeholder {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  letter-spacing: 0;
  font-weight: 600;
}

.emr-catalog__token {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 7px;
  background: #eceff1;
  color: #37474f;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.emr-catalog__address {
  max-width: 260px;
  white-space: normal;
}

.emr-mz-dashboard table.emr-catalog__table--wide,
.emr-catalog__table--wide {
  min-width: 1080px;
}

@media only screen and (min-width: 1024px) {
  .emr-catalog__side {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
}

@media only screen and (min-width: 1440px) {
  .emr-catalog__workspace {
    grid-template-columns: minmax(280px, 340px) minmax(0, 1fr);
  }

  .emr-catalog__side {
    grid-template-columns: minmax(0, 1fr);
  }

  .emr-catalog--full-table .emr-catalog__workspace {
    grid-template-columns: minmax(0, 1fr);
  }

  .emr-catalog--full-table .emr-catalog__side {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
}

@media only screen and (max-width: 600px) {
  .emr-mz-dashboard .emr-catalog__title,
  .emr-catalog__title {
    font-size: 18px !important;
  }

  .emr-mz-dashboard .emr-catalog__table th,
  .emr-mz-dashboard .emr-catalog__table td {
    padding: 4px 10px;
  }

  .emr-mz-dashboard table.emr-catalog__table,
  .emr-catalog__table {
    min-width: 560px;
  }

  .emr-mz-dashboard table.emr-catalog__table--wide,
  .emr-catalog__table--wide {
    min-width: 960px;
  }

  .emr-catalog__pagehead {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .emr-mz-dashboard .btn.emr-catalog__btn,
  .emr-catalog__btn {
    width: 100%;
    justify-content: center;
  }

  .emr-catalog__filters {
    grid-template-columns: minmax(0, 1fr);
  }
}

.emr-catalog__subtitle {
  margin: 2px 0 0;
  font-size: 13px;
  font-weight: 400;
  color: var(--emr-catalog-muted);
}

.emr-mz-dashboard .btn.emr-catalog__btn,
.emr-catalog__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  padding: 0 14px;
  margin: 0;
  flex-shrink: 0;
  background: var(--emr-catalog-primary) !important;
  color: #fff !important;
  border: 0;
  box-shadow: none;
  text-transform: none;
  font-size: 13px;
  font-weight: 600;
  line-height: 36px;
}

.emr-mz-dashboard .btn.emr-catalog__btn:hover,
.emr-catalog__btn:hover {
  background: var(--emr-catalog-primary-dark) !important;
}

.emr-catalog__btn-icon {
  width: 16px;
  height: 16px;
}

.emr-mz-dashboard .btn.emr-catalog__btn--ghost,
.emr-catalog__btn--ghost {
  background: #fff !important;
  color: var(--emr-catalog-primary) !important;
  border: 1px solid var(--emr-catalog-primary);
}

.emr-mz-dashboard .btn.emr-catalog__btn--ghost:hover,
.emr-catalog__btn--ghost:hover {
  background: #e3f2fd !important;
}

.emr-mz-dashboard .btn.emr-catalog__btn--danger,
.emr-catalog__btn--danger {
  background: #d32f2f !important;
}

.emr-catalog__filters {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
  align-items: end;
  min-width: 0;
}

.emr-catalog__search {
  position: relative;
  min-width: 0;
  width: 100%;
}

.emr-catalog__search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  width: 16px;
  height: 16px;
  margin-top: -8px;
  color: #9e9e9e;
  pointer-events: none;
}

.emr-mz-dashboard .emr-catalog__input,
.emr-catalog__input,
.emr-mz-dashboard .emr-catalog__select,
.emr-catalog__select,
.emr-mz-dashboard .emr-catalog__filter-trigger,
.emr-catalog__filter-trigger {
  height: 36px !important;
  min-height: 36px !important;
  width: 100% !important;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box !important;
  margin: 0;
  border: 1px solid var(--emr-catalog-border) !important;
  background: var(--emr-catalog-surface) !important;
  box-shadow: none !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  color: var(--emr-catalog-text) !important;
}

.emr-mz-dashboard .emr-catalog__input,
.emr-catalog__input {
  padding: 0 10px 0 32px !important;
}

.emr-mz-dashboard .emr-catalog__select,
.emr-catalog__select {
  padding: 0 8px !important;
  display: block;
}

.emr-catalog-select {
  border-radius: 0 !important;
  border: 1px solid var(--emr-catalog-border) !important;
  background: #fff !important;
  box-shadow: none !important;
}

.emr-catalog__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.emr-catalog__field > span,
.emr-catalog__field-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--emr-catalog-muted);
}

.emr-catalog__switch {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 10px;
  border: 1px solid var(--emr-catalog-border);
  background: var(--emr-catalog-surface);
  font-size: 13px;
  color: var(--emr-catalog-text);
}

.emr-catalog__demo {
  display: inline-flex;
  align-items: center;
  height: 18px;
  margin-left: 8px;
  padding: 0 6px;
  background: #fff8e1;
  color: #f9a825;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  vertical-align: middle;
}

.emr-catalog__status--suspended {
  background: #fff8e1;
  color: #f9a825;
}

.emr-catalog__actions-col {
  text-align: right;
  white-space: nowrap;
}

.emr-catalog__row-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 2px;
}

.emr-catalog__chips {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 4px;
}

.emr-mz-dashboard .emr-catalog-icon-btn {
  width: 24px !important;
  height: 24px !important;
  min-width: 24px !important;
  min-height: 24px !important;
  padding: 0 !important;
  line-height: 1 !important;
  color: var(--emr-catalog-primary);
}

.emr-mz-dashboard .emr-catalog-icon-btn--danger {
  color: #d32f2f;
}

.emr-mz-dashboard a.emr-catalog__link,
.emr-catalog__link {
  color: var(--emr-catalog-primary-dark);
  font-weight: 600;
  text-decoration: none;
}

.emr-mz-dashboard a.emr-catalog__link:hover,
.emr-catalog__link:hover {
  text-decoration: underline;
}

.emr-catalog__pager {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--emr-catalog-border);
  font-size: 12px;
  color: var(--emr-catalog-muted);
}

.emr-catalog__cap {
  margin: 8px 0 0;
  padding: 6px 8px;
  background: #fff8e1;
  color: #5d4037;
  font-size: 12px;
  text-align: center;
}

.emr-catalog__meta {
  margin: 6px 0 0;
  font-size: 12px;
  color: var(--emr-catalog-muted);
}

.emr-catalog__text-btn {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 6px;
  border: 0;
  background: transparent;
  color: var(--emr-catalog-primary);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.emr-catalog__text-btn:hover {
  text-decoration: underline;
}

@media only screen and (min-width: 720px) {
  .emr-catalog__filters {
    grid-template-columns: minmax(0, 1.4fr) repeat(auto-fit, minmax(140px, 180px));
  }

  .emr-catalog__filters--search-only {
    grid-template-columns: minmax(0, 1fr);
    max-width: 420px;
  }

  .emr-catalog__filters--search-row {
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  }

  .emr-catalog__filters--search-row .emr-catalog__search {
    grid-column: 1 / -1;
    min-width: 0;
  }

  .emr-catalog__filters--vocab {
    grid-template-columns: minmax(22rem, max-content) max-content;
  }

  .emr-catalog__select--wide {
    width: auto !important;
    min-width: 22rem !important;
    max-width: 32rem;
  }
}

.emr-catalog--access {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
}

.emr-catalog--access .emr-catalog__pagehead {
  margin-bottom: 0;
}

.emr-catalog--access .emr-catalog__workspace {
  gap: 8px;
}

.emr-catalog--access .ac-tabs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin: 0;
}

.emr-catalog--access .ac-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  border: 1px solid var(--emr-catalog-border);
  background: #fff;
  padding: 8px 10px;
  text-align: left;
  color: var(--emr-catalog-text);
}

.emr-catalog--access .ac-tab.is-active {
  border-color: var(--emr-catalog-primary);
  box-shadow: inset 0 -3px 0 var(--emr-catalog-primary);
  color: var(--emr-catalog-primary-dark);
}

.emr-catalog--access .ac-tab.is-disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.emr-catalog--access .ac-tab-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
}

.emr-catalog--access .ac-tab-sub {
  display: block;
  font-size: 11px;
  color: var(--emr-catalog-muted);
}

.emr-catalog--access .ac-toolbar,
.emr-catalog--access .ac-toolbar--user {
  display: grid;
  grid-template-columns: minmax(160px, 240px) minmax(0, 1fr);
  gap: 8px;
  margin: 0;
  align-items: start;
}

.emr-catalog--access .ac-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--emr-catalog-muted);
}

.emr-mz-dashboard .emr-catalog--access .ac-field select,
.emr-catalog--access .ac-field select {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  width: 100%;
  max-width: 100%;
  height: 36px !important;
  min-height: 36px !important;
  margin: 0;
  border: 1px solid var(--emr-catalog-border);
  background: #fff;
  padding: 0 8px;
  font-size: 13px;
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
  color: var(--emr-catalog-text);
  appearance: auto;
  -webkit-appearance: menulist;
}

.emr-catalog--access .ac-info {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  margin: 0;
  background: #e3f2fd;
  border: 1px solid #bbdefb;
  color: var(--emr-catalog-primary-dark);
  padding: 8px 10px;
  font-size: 13px;
}

.emr-catalog--access .ac-employee {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
  margin: 0;
  border: 0;
  padding: 0;
  background: transparent;
}

.emr-catalog--access .ac-employee span {
  display: block;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--emr-catalog-muted);
  font-weight: 600;
}

.emr-catalog--access .ac-employee strong {
  display: block;
  margin-top: 2px;
  font-size: 13px;
  color: var(--emr-catalog-text);
  font-weight: 600;
}

.emr-catalog--access .ac-matrix,
.emr-catalog--access .ac-hierarchy {
  border-radius: 0 !important;
  overflow-x: auto;
  max-width: 100%;
}

.emr-catalog--access .ac-matrix-table th,
.emr-catalog--access .ac-matrix-table td {
  padding: 6px 8px;
}

.emr-catalog--access .ac-footer,
.emr-catalog--access .ac-footer--user {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 0;
}

.emr-catalog--access .ac-save--default,
.emr-catalog--access .ac-save--user {
  background: var(--emr-catalog-primary) !important;
  color: #fff !important;
}

.emr-catalog--access .ac-save--default:hover,
.emr-catalog--access .ac-save--user:hover {
  background: var(--emr-catalog-primary-dark) !important;
}

.emr-catalog--access .ac-loading,
.emr-catalog--access .ac-footnote {
  margin: 0;
  font-size: 13px;
  color: var(--emr-catalog-muted);
}

@media only screen and (max-width: 900px) {
  .emr-catalog--access .ac-tabs,
  .emr-catalog--access .ac-toolbar,
  .emr-catalog--access .ac-toolbar--user,
  .emr-catalog--access .ac-employee,
  .emr-catalog--access .ac-footer,
  .emr-catalog--access .ac-footer--user {
    grid-template-columns: minmax(0, 1fr);
    display: flex;
    flex-direction: column;
  }
}

.emr-catalog--access .ac-workspace-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin: 0;
}

.emr-catalog--access .ac-workspace-tab {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
  border: 1px solid var(--emr-catalog-border);
  background: #fff;
  padding: 10px 12px;
  text-align: left;
  color: var(--emr-catalog-text);
}

.emr-catalog--access .ac-workspace-tab.is-active {
  border-color: var(--emr-catalog-primary);
  background: #e3f2fd;
  box-shadow: inset 0 -3px 0 var(--emr-catalog-primary);
  color: var(--emr-catalog-primary-dark);
}

.emr-catalog--access .ac-role-help {
  flex-shrink: 0;
}

.emr-catalog--access .ac-perm {
  display: grid;
  gap: 8px;
  min-width: 0;
}

.emr-catalog--access .ac-perm-title {
  margin: 0;
  font-size: 16px !important;
  font-weight: 600;
  color: var(--emr-catalog-text);
  text-transform: none;
  letter-spacing: 0;
}

.emr-catalog--access .ac-perm-subtitle,
.emr-catalog--access .ac-perm-preferred-note {
  margin: 2px 0 0;
  font-size: 12px;
  color: var(--emr-catalog-muted);
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
}

.emr-catalog--access .ac-perm-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.emr-catalog--access .ac-perm-preferred {
  height: 32px;
  padding: 0 10px;
}

.emr-catalog--access .ac-perm-guide {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--emr-catalog-primary-dark);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.emr-catalog--access .ac-perm-guide svg {
  width: 14px;
  height: 14px;
}

.emr-catalog--access .ac-perm-group-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 6px;
  font-size: 13px !important;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: none;
  color: var(--emr-catalog-text);
}

.emr-catalog--access .ac-perm-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  background: #e3f2fd;
  color: var(--emr-catalog-primary-dark);
  font-size: 11px;
  font-weight: 700;
}

.emr-catalog--access .ac-perm-table-wrap {
  overflow-x: auto;
  max-width: 100%;
}

.emr-catalog--access .ac-perm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.emr-catalog--access .ac-perm-table th,
.emr-catalog--access .ac-perm-table td {
  border-bottom: 1px solid var(--emr-catalog-border);
  padding: 4px 8px;
  text-align: left;
  vertical-align: middle;
}

.emr-catalog--access .ac-perm-table thead th {
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--emr-catalog-muted);
  background: #fafafa;
  white-space: nowrap;
}

.emr-catalog--access .ac-perm-table thead th:not(:first-child),
.emr-catalog--access .ac-perm-table td {
  text-align: center;
  width: 110px;
}

.emr-catalog--access .ac-perm-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  color: var(--emr-catalog-text);
}

.emr-catalog--access .ac-perm-info {
  position: relative;
  display: inline-flex;
}

.emr-catalog--access .ac-perm-info-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--emr-catalog-muted);
  cursor: pointer;
}

.emr-catalog--access .ac-perm-info-btn svg {
  width: 13px;
  height: 13px;
}

.emr-catalog--access .ac-perm-tip {
  display: none;
  position: absolute;
  left: 0;
  top: 20px;
  z-index: 8;
  min-width: 180px;
  max-width: 260px;
  padding: 6px 8px;
  background: #0d47a1;
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.35;
  box-shadow: 0 2px 8px rgba(13, 71, 161, 0.25);
}

.emr-catalog--access .ac-perm-info:hover .ac-perm-tip,
.emr-catalog--access .ac-perm-info:focus-within .ac-perm-tip,
.emr-catalog--access .ac-perm-info.is-open .ac-perm-tip {
  display: block;
}

.emr-catalog--access .ac-perm-check-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.emr-mz-dashboard .emr-catalog--access input.ac-perm-check[type="checkbox"],
.emr-catalog--access input.ac-perm-check[type="checkbox"] {
  position: static !important;
  left: auto !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  visibility: visible !important;
  appearance: auto !important;
  -webkit-appearance: checkbox !important;
  width: 16px !important;
  height: 16px !important;
  margin: 0 !important;
  z-index: auto !important;
  accent-color: #1976d2;
}

.emr-catalog--access .ac-perm-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 0;
}

.emr-catalog--access .ac-perm-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.emr-catalog--access .ac-role-copy {
  display: grid;
  gap: 8px;
  text-align: left;
  color: var(--emr-catalog-text);
}

.emr-catalog--access .ac-role-copy p {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
}

@media only screen and (max-width: 1100px) {
  .emr-catalog--access .ac-workspace-tabs {
    grid-template-columns: minmax(0, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/emr-catalog.css"],"names":[],"mappings":"AAAA;;;8CAG8C;;AAE9C;;;;EAIE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;EACtC,2CAA2C;EAC3C,kDAAkD;EAClD,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,4CAA4C;EAC5C,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;EACjB,kDAAkD;EAClD,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,+GAA+G;EAC/G,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,0DAA0D;EAC5D;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,SAAS;EACT,cAAc;EACd,iDAAiD;EACjD,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,2BAA2B;EAC3B,4CAA4C;EAC5C,4CAA4C;AAC9C;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;;;;;;EAME,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,SAAS;EACT,sDAAsD;EACtD,iDAAiD;EACjD,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,sDAAsD;EACtD,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,sCAAsC;EACtC,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,sCAAsC;EACtC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,8EAA8E;EAChF;;EAEA;IACE,qCAAqC;IACrC,gBAAgB;EAClB;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,qDAAqD;EACrD,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;AACjC;;AAEA;;EAEE,aAAa;EACb,0DAA0D;EAC1D,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;EACT,2CAA2C;EAC3C,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,sCAAsC;EACtC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,SAAS;EACT,SAAS;EACT,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,SAAS;AACX;;AAEA;;EAEE,iDAAiD;EACjD,sBAAsB;AACxB;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE;;;;;;IAME,qCAAqC;IACrC,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,qDAAqD;EACrD,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,kDAAkD;EAClD,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;;EAEE,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,uCAAuC;EACvC,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":["/* Catalog-style list pages: Medications, Labs, Radiology, Physician Referrals,\n * Referring Providers, CPT, Organizations, Locations, ICD-10-CM, SmartPhrases,\n * Users, Access Control, Allergen Master, and Px Master.\n * Namespaced so other pages stay unchanged. */\n\n.emr-catalog,\n.emr-catalog *,\n.emr-catalog *::before,\n.emr-catalog *::after {\n  border-radius: 0 !important;\n}\n\n.emr-mz-dashboard .emr-mz-main:has(.emr-catalog) {\n  padding: 10px 12px 12px !important;\n  max-width: none;\n  overflow-x: hidden;\n}\n\n.emr-catalog {\n  --emr-catalog-primary: #1976d2;\n  --emr-catalog-primary-dark: #0d47a1;\n  --emr-catalog-text: #212121;\n  --emr-catalog-muted: #616161;\n  --emr-catalog-border: #e0e0e0;\n  --emr-catalog-surface: #ffffff;\n  max-width: none;\n  margin: 0;\n  min-width: 0;\n  width: 100%;\n  box-sizing: border-box;\n  color: var(--emr-catalog-text);\n  overflow-x: hidden;\n}\n\n.emr-catalog__pagehead {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n  min-width: 0;\n}\n\n.emr-mz-dashboard .emr-catalog__title,\n.emr-catalog__title {\n  margin: 0;\n  font-size: 20px !important;\n  font-weight: 600;\n  line-height: 1.25;\n  color: var(--emr-catalog-text);\n}\n\n.emr-catalog__workspace {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 8px;\n  align-items: start;\n  min-width: 0;\n}\n\n.emr-catalog__side {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 8px;\n  align-content: start;\n  min-width: 0;\n}\n\n.emr-catalog__catalog {\n  min-width: 0;\n}\n\n.emr-catalog .card.emr-catalog__section,\n.emr-catalog__section {\n  margin: 0;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  background: var(--emr-catalog-surface);\n  border: 1px solid var(--emr-catalog-border);\n  border-right: 3px solid var(--emr-catalog-primary);\n  box-shadow: none;\n  padding: 8px 12px 10px;\n  box-sizing: border-box;\n}\n\n.emr-catalog__section-title {\n  margin: 0 0 6px;\n  font-size: 11px !important;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--emr-catalog-muted);\n}\n\n.emr-catalog__copy {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--emr-catalog-text);\n}\n\n.emr-catalog__section--notice {\n  background: #fff8e1;\n  border-color: #ffe082;\n  border-right-width: 3px;\n  border-right-color: var(--emr-catalog-primary);\n}\n\n.emr-catalog__section--notice .emr-catalog__section-title {\n  color: #f57f17;\n}\n\n.emr-catalog__section--notice .emr-catalog__copy {\n  color: #5d4037;\n}\n\n.emr-catalog__status-msg,\n.emr-catalog__empty {\n  padding: 28px 16px;\n  text-align: center;\n  font-size: 13px;\n  color: var(--emr-catalog-muted);\n}\n\n.emr-catalog__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.emr-catalog__empty-icon {\n  width: 32px;\n  height: 32px;\n  color: #bdbdbd;\n}\n\n.emr-catalog__error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 28px 16px;\n  text-align: center;\n}\n\n.emr-catalog__error-icon {\n  width: 32px;\n  height: 32px;\n  color: #ef9a9a;\n}\n\n.emr-catalog__error-copy {\n  margin: 0;\n  max-width: 28rem;\n  font-size: 13px;\n  color: var(--emr-catalog-muted);\n}\n\n.emr-mz-dashboard .btn.emr-catalog__retry,\n.emr-catalog__retry {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 36px;\n  padding: 0 14px;\n  margin: 0;\n  background: #fff !important;\n  color: var(--emr-catalog-primary) !important;\n  border: 1px solid var(--emr-catalog-primary);\n  box-shadow: none;\n}\n\n.emr-mz-dashboard .btn.emr-catalog__retry:hover,\n.emr-catalog__retry:hover {\n  background: #e3f2fd !important;\n}\n\n.emr-catalog__table-wrap {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n}\n\n.emr-mz-dashboard table.emr-catalog__table,\n.emr-catalog__table {\n  display: table;\n  width: 100%;\n  min-width: 720px;\n  border-collapse: collapse;\n  position: static;\n}\n\n.emr-mz-dashboard table.emr-catalog__table thead {\n  display: table-header-group;\n  position: static;\n  float: none;\n  overflow: visible;\n  width: auto;\n}\n\n.emr-mz-dashboard table.emr-catalog__table tbody {\n  display: table-row-group;\n}\n\n.emr-mz-dashboard table.emr-catalog__table tr {\n  display: table-row;\n}\n\n.emr-mz-dashboard table.emr-catalog__table th,\n.emr-mz-dashboard table.emr-catalog__table td {\n  display: table-cell;\n  line-height: 1.25;\n}\n\n.emr-mz-dashboard .emr-catalog__table th {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--emr-catalog-muted);\n  padding: 4px 12px;\n  line-height: 1.25;\n  border-bottom: 1px solid var(--emr-catalog-border);\n  background: #fafbfc;\n  white-space: nowrap;\n}\n\n.emr-mz-dashboard .emr-catalog__table td {\n  font-size: 13px;\n  font-weight: 400;\n  padding: 4px 12px;\n  line-height: 1.25;\n  color: var(--emr-catalog-text);\n  border-bottom: 1px solid #f0f0f0;\n  vertical-align: middle;\n}\n\n.emr-catalog__name {\n  font-weight: 600;\n  color: var(--emr-catalog-primary-dark);\n}\n\n.emr-catalog__muted {\n  font-size: 13px;\n  color: var(--emr-catalog-muted);\n}\n\n.emr-catalog__status {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n.emr-catalog__status--active {\n  background: #e3f2fd;\n  color: #1565c0;\n}\n\n.emr-catalog__status--transform {\n  background: #fff8e1;\n  color: #f57f17;\n}\n\n.emr-catalog__status--inactive {\n  background: #eceff1;\n  color: #546e7a;\n}\n\n.emr-catalog__token--placeholder {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  letter-spacing: 0;\n  font-weight: 600;\n}\n\n.emr-catalog__token {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 7px;\n  background: #eceff1;\n  color: #37474f;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n.emr-catalog__address {\n  max-width: 260px;\n  white-space: normal;\n}\n\n.emr-mz-dashboard table.emr-catalog__table--wide,\n.emr-catalog__table--wide {\n  min-width: 1080px;\n}\n\n@media only screen and (min-width: 1024px) {\n  .emr-catalog__side {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n}\n\n@media only screen and (min-width: 1440px) {\n  .emr-catalog__workspace {\n    grid-template-columns: minmax(280px, 340px) minmax(0, 1fr);\n  }\n\n  .emr-catalog__side {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .emr-catalog--full-table .emr-catalog__workspace {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .emr-catalog--full-table .emr-catalog__side {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .emr-mz-dashboard .emr-catalog__title,\n  .emr-catalog__title {\n    font-size: 18px !important;\n  }\n\n  .emr-mz-dashboard .emr-catalog__table th,\n  .emr-mz-dashboard .emr-catalog__table td {\n    padding: 4px 10px;\n  }\n\n  .emr-mz-dashboard table.emr-catalog__table,\n  .emr-catalog__table {\n    min-width: 560px;\n  }\n\n  .emr-mz-dashboard table.emr-catalog__table--wide,\n  .emr-catalog__table--wide {\n    min-width: 960px;\n  }\n\n  .emr-catalog__pagehead {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n  }\n\n  .emr-mz-dashboard .btn.emr-catalog__btn,\n  .emr-catalog__btn {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .emr-catalog__filters {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n.emr-catalog__subtitle {\n  margin: 2px 0 0;\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--emr-catalog-muted);\n}\n\n.emr-mz-dashboard .btn.emr-catalog__btn,\n.emr-catalog__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 14px;\n  margin: 0;\n  flex-shrink: 0;\n  background: var(--emr-catalog-primary) !important;\n  color: #fff !important;\n  border: 0;\n  box-shadow: none;\n  text-transform: none;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 36px;\n}\n\n.emr-mz-dashboard .btn.emr-catalog__btn:hover,\n.emr-catalog__btn:hover {\n  background: var(--emr-catalog-primary-dark) !important;\n}\n\n.emr-catalog__btn-icon {\n  width: 16px;\n  height: 16px;\n}\n\n.emr-mz-dashboard .btn.emr-catalog__btn--ghost,\n.emr-catalog__btn--ghost {\n  background: #fff !important;\n  color: var(--emr-catalog-primary) !important;\n  border: 1px solid var(--emr-catalog-primary);\n}\n\n.emr-mz-dashboard .btn.emr-catalog__btn--ghost:hover,\n.emr-catalog__btn--ghost:hover {\n  background: #e3f2fd !important;\n}\n\n.emr-mz-dashboard .btn.emr-catalog__btn--danger,\n.emr-catalog__btn--danger {\n  background: #d32f2f !important;\n}\n\n.emr-catalog__filters {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 8px;\n  align-items: end;\n  min-width: 0;\n}\n\n.emr-catalog__search {\n  position: relative;\n  min-width: 0;\n  width: 100%;\n}\n\n.emr-catalog__search-icon {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  width: 16px;\n  height: 16px;\n  margin-top: -8px;\n  color: #9e9e9e;\n  pointer-events: none;\n}\n\n.emr-mz-dashboard .emr-catalog__input,\n.emr-catalog__input,\n.emr-mz-dashboard .emr-catalog__select,\n.emr-catalog__select,\n.emr-mz-dashboard .emr-catalog__filter-trigger,\n.emr-catalog__filter-trigger {\n  height: 36px !important;\n  min-height: 36px !important;\n  width: 100% !important;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box !important;\n  margin: 0;\n  border: 1px solid var(--emr-catalog-border) !important;\n  background: var(--emr-catalog-surface) !important;\n  box-shadow: none !important;\n  font-size: 13px !important;\n  font-weight: 400 !important;\n  color: var(--emr-catalog-text) !important;\n}\n\n.emr-mz-dashboard .emr-catalog__input,\n.emr-catalog__input {\n  padding: 0 10px 0 32px !important;\n}\n\n.emr-mz-dashboard .emr-catalog__select,\n.emr-catalog__select {\n  padding: 0 8px !important;\n  display: block;\n}\n\n.emr-catalog-select {\n  border-radius: 0 !important;\n  border: 1px solid var(--emr-catalog-border) !important;\n  background: #fff !important;\n  box-shadow: none !important;\n}\n\n.emr-catalog__field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.emr-catalog__field > span,\n.emr-catalog__field-label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--emr-catalog-muted);\n}\n\n.emr-catalog__switch {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 10px;\n  border: 1px solid var(--emr-catalog-border);\n  background: var(--emr-catalog-surface);\n  font-size: 13px;\n  color: var(--emr-catalog-text);\n}\n\n.emr-catalog__demo {\n  display: inline-flex;\n  align-items: center;\n  height: 18px;\n  margin-left: 8px;\n  padding: 0 6px;\n  background: #fff8e1;\n  color: #f9a825;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  vertical-align: middle;\n}\n\n.emr-catalog__status--suspended {\n  background: #fff8e1;\n  color: #f9a825;\n}\n\n.emr-catalog__actions-col {\n  text-align: right;\n  white-space: nowrap;\n}\n\n.emr-catalog__row-actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 2px;\n}\n\n.emr-catalog__chips {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  gap: 4px;\n}\n\n.emr-mz-dashboard .emr-catalog-icon-btn {\n  width: 24px !important;\n  height: 24px !important;\n  min-width: 24px !important;\n  min-height: 24px !important;\n  padding: 0 !important;\n  line-height: 1 !important;\n  color: var(--emr-catalog-primary);\n}\n\n.emr-mz-dashboard .emr-catalog-icon-btn--danger {\n  color: #d32f2f;\n}\n\n.emr-mz-dashboard a.emr-catalog__link,\n.emr-catalog__link {\n  color: var(--emr-catalog-primary-dark);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.emr-mz-dashboard a.emr-catalog__link:hover,\n.emr-catalog__link:hover {\n  text-decoration: underline;\n}\n\n.emr-catalog__pager {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid var(--emr-catalog-border);\n  font-size: 12px;\n  color: var(--emr-catalog-muted);\n}\n\n.emr-catalog__cap {\n  margin: 8px 0 0;\n  padding: 6px 8px;\n  background: #fff8e1;\n  color: #5d4037;\n  font-size: 12px;\n  text-align: center;\n}\n\n.emr-catalog__meta {\n  margin: 6px 0 0;\n  font-size: 12px;\n  color: var(--emr-catalog-muted);\n}\n\n.emr-catalog__text-btn {\n  display: inline-flex;\n  align-items: center;\n  height: 24px;\n  padding: 0 6px;\n  border: 0;\n  background: transparent;\n  color: var(--emr-catalog-primary);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.emr-catalog__text-btn:hover {\n  text-decoration: underline;\n}\n\n@media only screen and (min-width: 720px) {\n  .emr-catalog__filters {\n    grid-template-columns: minmax(0, 1.4fr) repeat(auto-fit, minmax(140px, 180px));\n  }\n\n  .emr-catalog__filters--search-only {\n    grid-template-columns: minmax(0, 1fr);\n    max-width: 420px;\n  }\n\n  .emr-catalog__filters--search-row {\n    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  }\n\n  .emr-catalog__filters--search-row .emr-catalog__search {\n    grid-column: 1 / -1;\n    min-width: 0;\n  }\n\n  .emr-catalog__filters--vocab {\n    grid-template-columns: minmax(22rem, max-content) max-content;\n  }\n\n  .emr-catalog__select--wide {\n    width: auto !important;\n    min-width: 22rem !important;\n    max-width: 32rem;\n  }\n}\n\n.emr-catalog--access {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 8px;\n}\n\n.emr-catalog--access .emr-catalog__pagehead {\n  margin-bottom: 0;\n}\n\n.emr-catalog--access .emr-catalog__workspace {\n  gap: 8px;\n}\n\n.emr-catalog--access .ac-tabs {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  margin: 0;\n}\n\n.emr-catalog--access .ac-tab {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  border: 1px solid var(--emr-catalog-border);\n  background: #fff;\n  padding: 8px 10px;\n  text-align: left;\n  color: var(--emr-catalog-text);\n}\n\n.emr-catalog--access .ac-tab.is-active {\n  border-color: var(--emr-catalog-primary);\n  box-shadow: inset 0 -3px 0 var(--emr-catalog-primary);\n  color: var(--emr-catalog-primary-dark);\n}\n\n.emr-catalog--access .ac-tab.is-disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.emr-catalog--access .ac-tab-label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.emr-catalog--access .ac-tab-sub {\n  display: block;\n  font-size: 11px;\n  color: var(--emr-catalog-muted);\n}\n\n.emr-catalog--access .ac-toolbar,\n.emr-catalog--access .ac-toolbar--user {\n  display: grid;\n  grid-template-columns: minmax(160px, 240px) minmax(0, 1fr);\n  gap: 8px;\n  margin: 0;\n  align-items: start;\n}\n\n.emr-catalog--access .ac-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--emr-catalog-muted);\n}\n\n.emr-mz-dashboard .emr-catalog--access .ac-field select,\n.emr-catalog--access .ac-field select {\n  display: block !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n  width: 100%;\n  max-width: 100%;\n  height: 36px !important;\n  min-height: 36px !important;\n  margin: 0;\n  border: 1px solid var(--emr-catalog-border);\n  background: #fff;\n  padding: 0 8px;\n  font-size: 13px;\n  font-weight: 400;\n  text-transform: none;\n  letter-spacing: 0;\n  color: var(--emr-catalog-text);\n  appearance: auto;\n  -webkit-appearance: menulist;\n}\n\n.emr-catalog--access .ac-info {\n  display: flex;\n  gap: 8px;\n  align-items: flex-start;\n  margin: 0;\n  background: #e3f2fd;\n  border: 1px solid #bbdefb;\n  color: var(--emr-catalog-primary-dark);\n  padding: 8px 10px;\n  font-size: 13px;\n}\n\n.emr-catalog--access .ac-employee {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 8px;\n  margin: 0;\n  border: 0;\n  padding: 0;\n  background: transparent;\n}\n\n.emr-catalog--access .ac-employee span {\n  display: block;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--emr-catalog-muted);\n  font-weight: 600;\n}\n\n.emr-catalog--access .ac-employee strong {\n  display: block;\n  margin-top: 2px;\n  font-size: 13px;\n  color: var(--emr-catalog-text);\n  font-weight: 600;\n}\n\n.emr-catalog--access .ac-matrix,\n.emr-catalog--access .ac-hierarchy {\n  border-radius: 0 !important;\n  overflow-x: auto;\n  max-width: 100%;\n}\n\n.emr-catalog--access .ac-matrix-table th,\n.emr-catalog--access .ac-matrix-table td {\n  padding: 6px 8px;\n}\n\n.emr-catalog--access .ac-footer,\n.emr-catalog--access .ac-footer--user {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin: 0;\n}\n\n.emr-catalog--access .ac-save--default,\n.emr-catalog--access .ac-save--user {\n  background: var(--emr-catalog-primary) !important;\n  color: #fff !important;\n}\n\n.emr-catalog--access .ac-save--default:hover,\n.emr-catalog--access .ac-save--user:hover {\n  background: var(--emr-catalog-primary-dark) !important;\n}\n\n.emr-catalog--access .ac-loading,\n.emr-catalog--access .ac-footnote {\n  margin: 0;\n  font-size: 13px;\n  color: var(--emr-catalog-muted);\n}\n\n@media only screen and (max-width: 900px) {\n  .emr-catalog--access .ac-tabs,\n  .emr-catalog--access .ac-toolbar,\n  .emr-catalog--access .ac-toolbar--user,\n  .emr-catalog--access .ac-employee,\n  .emr-catalog--access .ac-footer,\n  .emr-catalog--access .ac-footer--user {\n    grid-template-columns: minmax(0, 1fr);\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.emr-catalog--access .ac-workspace-tabs {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  margin: 0;\n}\n\n.emr-catalog--access .ac-workspace-tab {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  min-width: 0;\n  border: 1px solid var(--emr-catalog-border);\n  background: #fff;\n  padding: 10px 12px;\n  text-align: left;\n  color: var(--emr-catalog-text);\n}\n\n.emr-catalog--access .ac-workspace-tab.is-active {\n  border-color: var(--emr-catalog-primary);\n  background: #e3f2fd;\n  box-shadow: inset 0 -3px 0 var(--emr-catalog-primary);\n  color: var(--emr-catalog-primary-dark);\n}\n\n.emr-catalog--access .ac-role-help {\n  flex-shrink: 0;\n}\n\n.emr-catalog--access .ac-perm {\n  display: grid;\n  gap: 8px;\n  min-width: 0;\n}\n\n.emr-catalog--access .ac-perm-title {\n  margin: 0;\n  font-size: 16px !important;\n  font-weight: 600;\n  color: var(--emr-catalog-text);\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.emr-catalog--access .ac-perm-subtitle,\n.emr-catalog--access .ac-perm-preferred-note {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: var(--emr-catalog-muted);\n  font-weight: 400;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.emr-catalog--access .ac-perm-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 8px;\n  flex-wrap: wrap;\n}\n\n.emr-catalog--access .ac-perm-preferred {\n  height: 32px;\n  padding: 0 10px;\n}\n\n.emr-catalog--access .ac-perm-guide {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--emr-catalog-primary-dark);\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.emr-catalog--access .ac-perm-guide svg {\n  width: 14px;\n  height: 14px;\n}\n\n.emr-catalog--access .ac-perm-group-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 6px;\n  font-size: 13px !important;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: none;\n  color: var(--emr-catalog-text);\n}\n\n.emr-catalog--access .ac-perm-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  background: #e3f2fd;\n  color: var(--emr-catalog-primary-dark);\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.emr-catalog--access .ac-perm-table-wrap {\n  overflow-x: auto;\n  max-width: 100%;\n}\n\n.emr-catalog--access .ac-perm-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.emr-catalog--access .ac-perm-table th,\n.emr-catalog--access .ac-perm-table td {\n  border-bottom: 1px solid var(--emr-catalog-border);\n  padding: 4px 8px;\n  text-align: left;\n  vertical-align: middle;\n}\n\n.emr-catalog--access .ac-perm-table thead th {\n  font-size: 11px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--emr-catalog-muted);\n  background: #fafafa;\n  white-space: nowrap;\n}\n\n.emr-catalog--access .ac-perm-table thead th:not(:first-child),\n.emr-catalog--access .ac-perm-table td {\n  text-align: center;\n  width: 110px;\n}\n\n.emr-catalog--access .ac-perm-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n  color: var(--emr-catalog-text);\n}\n\n.emr-catalog--access .ac-perm-info {\n  position: relative;\n  display: inline-flex;\n}\n\n.emr-catalog--access .ac-perm-info-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--emr-catalog-muted);\n  cursor: pointer;\n}\n\n.emr-catalog--access .ac-perm-info-btn svg {\n  width: 13px;\n  height: 13px;\n}\n\n.emr-catalog--access .ac-perm-tip {\n  display: none;\n  position: absolute;\n  left: 0;\n  top: 20px;\n  z-index: 8;\n  min-width: 180px;\n  max-width: 260px;\n  padding: 6px 8px;\n  background: #0d47a1;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.35;\n  box-shadow: 0 2px 8px rgba(13, 71, 161, 0.25);\n}\n\n.emr-catalog--access .ac-perm-info:hover .ac-perm-tip,\n.emr-catalog--access .ac-perm-info:focus-within .ac-perm-tip,\n.emr-catalog--access .ac-perm-info.is-open .ac-perm-tip {\n  display: block;\n}\n\n.emr-catalog--access .ac-perm-check-wrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n}\n\n.emr-mz-dashboard .emr-catalog--access input.ac-perm-check[type=\"checkbox\"],\n.emr-catalog--access input.ac-perm-check[type=\"checkbox\"] {\n  position: static !important;\n  left: auto !important;\n  opacity: 1 !important;\n  pointer-events: auto !important;\n  visibility: visible !important;\n  appearance: auto !important;\n  -webkit-appearance: checkbox !important;\n  width: 16px !important;\n  height: 16px !important;\n  margin: 0 !important;\n  z-index: auto !important;\n  accent-color: #1976d2;\n}\n\n.emr-catalog--access .ac-perm-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: 0;\n}\n\n.emr-catalog--access .ac-perm-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.emr-catalog--access .ac-role-copy {\n  display: grid;\n  gap: 8px;\n  text-align: left;\n  color: var(--emr-catalog-text);\n}\n\n.emr-catalog--access .ac-role-copy p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n@media only screen and (max-width: 1100px) {\n  .emr-catalog--access .ac-workspace-tabs {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
